module.exports = __webpack_public_path__ + "20d1e469a37846bb4b6d30a38b5301f4.png";